<app-modal
  #deleteTrainModal
  [modalMessage]="app.text.train.deleteMessage"
  [modalTitle]="app.text.train.modalTitle"
  (ok)="delete()"
></app-modal>
<div class="row">
  <div class="col-md-12">
    <div class="controls">
      @if (!app.train.isNew && trainId !== undefined) {
        <span>
          <app-unlock [id]="trainId">
            @if (
              app.train.modelHasChanges || app.train.isNew) {
              <button
                class="btn pull-right"
                [title]="app.text.impact.discard"
                (click)="discardChanges()"
                >
                <i class="fa fa-times"></i>
              </button>
              @if (
                app.field.getInvalidFields('train').length < 1 &&
                app.train.modelHasChanges
                ) {
                <button
                  class="btn pull-right"
                  (click)="app.train.save()"
                  [title]="app.text.impact.save"
                  >
                  <i class="fa fa-check"></i>
                </button>
              }
            } @else {
              <button
                class="btn pull-right"
                (click)="discardChanges()"
                [title]="app.text.impact.close"
                >
                <i class="fa fa-times"></i>
              </button>
            }
          </app-unlock>
        </span>
      }
      @if (app.unlockedId == null) {
        <span>
          @if (!app.train.isNew) {
            <span>
              <button
                class="btn"
                (click)="navigateToListView()"
                [title]="app.text.impact.close"
                >
                <i class="fa fa-times"></i>
              </button>
              <button
                class="btn"
                (click)="deleteTrainModal.open()"
                [title]="app.text.train.deleteTrain"
                >
                <i class="fa fa-trash"></i>
              </button>
            </span>
          }
        </span>
      }
      @if (app.train.isNew) {
        <div class="col-md-12">
          @if (app.field.getInvalidFields('train').length === 0) {
            <span>
              <button
                class="btn"
                (click)="app.train.save()"
                [title]="app.text.impact.save"
                >
                <i class="fa fa-check"></i>
              </button>
            </span>
          }
          <button
            class="btn"
            (click)="navigateToListView()"
            [title]="app.text.impact.close"
            >
            <i class="fa fa-times"></i>
          </button>
        </div>
      }
    </div>
    <div class="col-md-12 mt-5">
      <app-box
        [box]="app.listId.train.trains"
        [unlock]="trainId"
        [model]="app.model"
      ></app-box>
    </div>
  </div>
</div>
